import { AppState } from 'Store'
import { createSelector } from 'reselect'
import { ShortDataModel } from 'Models'

const selectEntries = (state: AppState) => state.adminSlice.merchant_status.list.entries
const selectCurrentParams = (state: AppState) => state.adminSlice.merchant_status.requestParams
const selectTotal = (state: AppState) => state.adminSlice.merchant_status.list.total_entries
const selectItem = (state: AppState) => state.adminSlice.merchant_status.edit
const getProductStatuses = (state: AppState) => state.adminSlice.merchant_status.statuses.entries
const getStatusParams = (state: AppState) => state.adminSlice.merchant_status.statusParams

const getProductStatusesSlug = createSelector(getProductStatuses, (statuses) =>
	statuses.map(
		(status): ShortDataModel => ({
			...status,
			id: status.id,
			name: status.slug,
		})
	)
)

export const merchantStatusSelectors = {
	selectEntries,
	selectTotal,
	selectCurrentParams,
	selectItem,
	getProductStatuses,
	getStatusParams,
	getProductStatusesSlug,
}
